import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssignDatasetsDialogComponent } from './assign-datasets-dialog.component';
import { FormModule, MaterialModule, SharedModule } from 'components';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [
    AssignDatasetsDialogComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    FormModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    SharedModule,
    MaterialModule
  ]
})
export class AssignDatasetsDialogModule { }
